<div class="container">
  <div class="container-table">
    <header class="top-header">
      <h3>Select Register</h3>
      <p>Choose a register to submit entry</p>
    </header>

    <div class="responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Register Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let register of registers">
            <td>{{ register.name }}</td>
            <td>
              <button class="action-button bt-edit" (click)="openRegister(register.id)" title="Select">
                <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="registers.length === 0">
            <td colspan="2">No active registers available.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
